/**
 * Small helpers for moving focus around and filling gaps in native keyboard behavior.
 */

/**
 * Elements that can receive focus. Used when moving focus into a newly shown step or past a
 * field. The `:not([disabled])` clauses matter: a control inside a `<fieldset disabled>` is
 * natively disabled and must not be treated as a focus target.
 */
export const FOCUSABLE_SELECTOR = [
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

/**
 * Toggles a checkbox on Enter.
 *
 * Native checkboxes respond to Space but ignore Enter, which surprises people. Attach this
 * as `onKeyDown` on a container and bubbling covers every checkbox inside it at once,
 * including MUI's (which render a real `<input type="checkbox">`).
 */
export const handleCheckboxEnter = (e) => {
  if (e.key !== 'Enter') {
    return;
  }
  const { target } = e;
  if (target instanceof HTMLInputElement && target.type === 'checkbox' && !target.disabled) {
    e.preventDefault();
    target.click();
  }
};
